/** @file Recorder.js
  * @brief Handles the video recording
  *
  * @author Justin Eslinger - Fivestone Studios
  * @date 07/23/2020
  *
  */
 import React from 'react';
import RecordRTCPromisesHandler from "recordrtc";
import { RecordEvent } from '../Analytics';
import {isSafari, sleep} from "../AppUtils";
import { mediaConstraints } from '../Config';
//import {invokeSaveAsDialog} from "recordrtc";

const videoBitRate = 2500000;
const audioBitRate = 128000;

class Recorder extends React.Component {

  constructor(props, videoIn, videoOut) {
    super(props);

    this.videoInId = videoIn;
    this.videoOutId = videoOut;

    this.videoIn = null;
    this.videoOut = null;

    this.vidBlob = null;

    this.recorder = null;
    this.stream = null;

    this.startRecord = this.startRecord.bind(this);
    this.playRecord = this.playRecord.bind(this);
    this.seekVideo = this.seekVideo.bind(this);
  }

  async startRecord(readyCallback) {
    var self = this;
    this.videoIn = document.getElementById(this.videoInId);

    try {
      self.stream = await navigator.mediaDevices.getUserMedia(mediaConstraints);
      
      const videoTracks = self.stream.getVideoTracks();
      console.log(`Using video device: ${videoTracks[0].label}`);

      window.stream = self.stream; // make variable available to browser console

      self.videoIn.srcObject = self.stream;
      self.videoIn.play();

      var mimeType = isSafari ? 'video/mp4' : 'video/webm';

      if (!isSafari) {
        self.videoIn.className="videoPreviewSelfie";
      }

      self.recorder = new RecordRTCPromisesHandler(self.stream, {
        type: 'video',
        mimeType: mimeType,
        getNativeBlob: true,
        videoBitsPerSecond: videoBitRate,
        audioBitsPerSecond: audioBitRate,
      });

      await sleep(2000);
      self.recorder.startRecording();
      readyCallback(true);
    } catch(error) {
      console.error();
      RecordEvent("Camera failed");
      readyCallback(false);
    }
  }

  getVidBlob() {
    return this.vidBlob;
  }

  stopRecord() {

    var self = this;

    this.videoOut = document.getElementById(this.videoOutId);

    this.recorder.stopRecording(function () {

      self.videoOut.src = self.videoIn.srcObject = null;

      self.vidBlob = self.recorder.getBlob();
      self.videoOut.src = URL.createObjectURL(self.vidBlob);

      // self.stream.getVideoTracks().forEach(function(track) {
      //   if (track.readyState === 'live') {
      //     track.stop();
      //   }
      // })

      //invokeSaveAsDialog(blob);
    });

  }

  seekVideo(time) {
    if (this.videoOut != null) {
      this.videoOut.currentTime = time;
    }
  }

  async playRecord() {

    if (this.videoOut != null) {
      this.videoOut.play();
    }
  }
}

export default Recorder;